<!-- 用电历史数据 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工单紧急程度">
              <a-select v-model="queryParam.ticketsEmergency" placeholder="请选择工单紧急程度">
                <a-select-option :value="0">正常</a-select-option>
                <a-select-option :value="1">紧急</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleHistory(record)">{{ $t('历史数据') }}</a>
        </span>

      </a-table>
    </div>

    <!-- <historicalDataModal ref="modalForm" @ok="loadData"></historicalDataModal> -->
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import historicalDataModal from './historicalDataModal'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'

  export default {
    name: 'index',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      // historicalDataModal
    },
    data () {
      return {
        description: '用电数据',
        url: {
          list: "/jeecg-charge/tyn/solarEnergyMeterElectricity/list",
          delete: "/jeecg-charge/tyn/solarEnergyMeterElectricity/delete",
          deleteBatch: "/jeecg-charge/tyn/solarEnergyMeterElectricity/deleteBatch",
          // exportXlsUrl: "/jeecg-charge/ticket/tickets/exportXls",
          // importExcelUrl: "jeecg-charge/ticket/tickets/importExcel",
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('当月累计充电量(KWH)'),
            align:"center",
            dataIndex: 'monthCharge'
          },
          {
            title: this.$t('当月累计用电量(KWH)'),
            align:"center",
            dataIndex: 'monthUseElectricity',
          },
          {
            title: this.$t('昨日充电量(KWH)'),
            dataIndex: 'yesterdayCharge',
            align:"center",
          },
          {
            title: this.$t('昨日用电量(KWH)'),
            align:"center",
            dataIndex: 'yesterdayUseElectricity',
          },
          {
            title: this.$t('日期'),
            align:"center",
            dataIndex: 'date'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      handleHistory(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row);
        })
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
